module.exports = __webpack_public_path__ + "img/channer_addressBook.5b2e61cf.svg";